export const userConstants = {
    REGISTER_REQUEST: 'USER_REGISTER_REQUEST',
    REGISTER_SUCCESS: 'USER_REGISTER_SUCCESS',
    REGISTER_FAILURE: 'USER_REGISTER_FAILURE',

    LOGIN_REQUEST: 'USER_LOGIN_REQUEST',
    LOGIN_SUCCESS: 'USER_LOGIN_SUCCESS',
    LOGIN_FAILURE: 'USER_LOGIN_FAILURE',
    
    GET_USER_REQUEST: 'GET_USER_REQUEST',
    GET_USER_SUCCESS: 'GET_USER_SUCCESS',
    GET_USER_FAILURE: 'GET_USER_FAILURE',
		
		GET_USER_SESSION_REQUEST: 'GET_USER_SESSION_REQUEST',
		GET_USER_SESSION_SUCCESS: 'GET_USER_SESSION_SUCCESS',
		GET_USER_SESSION_FAILURE: 'GET_USER_SESSION_FAILURE',

		GET_USER_ATTRIBUTES_REQUEST: 'GET_USER_ATTRIBUTES_REQUEST',
		GET_USER_ATTRIBUTES_SUCCESS: 'GET_USER_ATTRIBUTES_SUCCESS',
		GET_USER_ATTRIBUTES_FAILURE: 'GET_USER_ATTRIBUTES_FAILURE',

		GET_USER_WITH_ATTRIBUTES: 'GET_USER_WITH_ATTRIBUTES',
    LOGOUT: 'USER_LOGOUT'
};



// WEBPACK FOOTER //
// ./src/_constants/user.js